/* File: src/contexts/AuthContext.js */
import React, { createContext, useState, useContext, useEffect } from 'react';

// Création du contexte d'authentification
const AuthContext = createContext(null);

// Hook personnalisé pour utiliser le contexte d'authentification
export const useAuth = () => useContext(AuthContext);

// Fournisseur du contexte d'authentification
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Initialisation de l'état d'authentification à partir du localStorage
  useEffect(() => {
    // Récupérer l'utilisateur du localStorage
    const scannerUser = localStorage.getItem('scannerUser');
    if (scannerUser) {
      try {
        setUser(JSON.parse(scannerUser));
      } catch (err) {
        console.error('Error parsing stored user data:', err);
        localStorage.removeItem('scannerUser');
      }
    }
    setLoading(false);
  }, []);

  // Fonction de connexion pour le scanner
  const loginScanner = async (deviceId) => {
    try {
      setLoading(true);
      setError(null);
      
      // Pour la simplicité, on enregistre juste l'ID de l'appareil comme identifiant
      const userData = {
        id: Date.now(),
        username: deviceId,
        role: 'scanner'
      };
      
      // Stocker les données dans localStorage
      localStorage.setItem('scannerUser', JSON.stringify(userData));
      
      // Mettre à jour l'état
      setUser(userData);
      return true;
    } catch (err) {
      console.error('Login error:', err);
      setError(err.message || 'Erreur de connexion');
      return false;
    } finally {
      setLoading(false);
    }
  };

  // Fonction de déconnexion
  const logout = () => {
    // Supprimer les données d'authentification du localStorage
    localStorage.removeItem('scannerUser');
    
    // Réinitialiser l'état
    setUser(null);
  };

  // Vérifier si l'utilisateur est authentifié en tant que scanner
  const isScannerAuthenticated = !!user && user.role === 'scanner';

  // Valeur à fournir au contexte
  const value = {
    user,
    isScannerAuthenticated,
    loginScanner,
    logout,
    loading,
    error
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;